export { default } from './SectionImpact';